import React from 'react';
import { RefreshIcon } from 'components/icons';
import { useQueryClient } from '@tanstack/react-query';
import { SimQueryKey } from 'lib/hooks/sim/sim.hooks.keys';
import { useYourSimsContext } from 'views/YourSiMs/hooks';

function RefreshButton() {
  const queryClient = useQueryClient();
  const { getFilteredSimsParams } = useYourSimsContext();

  const refetchFilteredSims = () => {
    queryClient.refetchQueries([
      SimQueryKey.FILTERED_SIMS,
      JSON.stringify(getFilteredSimsParams()),
    ]);
  };

  return (
    <button
      onClick={refetchFilteredSims}
      className="btn btn-dark w-150 btn-refresh mr-3"
    >
      <RefreshIcon className="mr-2" /> Refresh
    </button>
  );
}

export default RefreshButton;
